import Axios from 'axios';
import { protectedResources } from '../authConfig';

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL =
  protectedResources.apiHRMobile.baseApi + '/api/v1/TimeInOut/GetSickLeaveInfo';
//const token           = getAccessToken;
let tokenKey;

export async function getSickDay(limit = 0, offset = 0, email = '') {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
      params: { 
      limit : limit,
      offset : offset,
      emailOrId : email 
    }
  };

  try {
    const getData = JSON.parse(sessionStorage.getItem('obj_sick_days'));
    if (getData === null) {
      const response = await Axios.get(URL, config);
      sessionStorage.setItem('obj_sick_days', JSON.stringify(response.data));
      return response.data;
    } else {
      return getData;
    }
  } catch (error) {
    if (error?.response?.status == 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    throw error;
  }
}
